import type { ReactNode } from "react"

import { cn } from "../../lib/utils"

type StatusTextVariant = "muted" | "error"

type StatusTextProps = {
  variant?: StatusTextVariant
  children: ReactNode
  className?: string
}

const variantClasses: Record<StatusTextVariant, string> = {
  muted: "text-muted-foreground",
  error: "text-destructive",
}

export function StatusText({ variant = "muted", className, children }: StatusTextProps) {
  return <div className={cn("text-sm", variantClasses[variant], className)}>{children}</div>
}
